import { ExternalId } from './ExternalId'

import camelCaseKeys from 'camelcase-keys'

export class Guest {
  constructor (params = {}) {
    const {
      id,
      sequence,
      bookingId,
      room,
      roomId,
      checkin,
      checkout,
      checkoutMoment,
      profile,
      profileId,
      account,
      accountId,
      externalIds,
      type,
      typeId,
      active,
      category,
      categoryId,
      keyConfigurationId,
      lastKeyGeneratedAt,
      dietRestrictions,
      registrationCard,
      registrationCardTotalSteps,
      registrationCardCompletedSteps
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.sequence = sequence || null
    this.bookingId = bookingId || null
    this.roomId = roomId || null
    this.room = room || this.roomId
    this.checkin = checkin || null
    this.checkout = checkout || null
    this.checkoutMoment = checkoutMoment || null
    this.profileId = profileId || null
    this.profile = profile || this.profileId
    this.accountId = accountId || null
    this.account = account || this.accountId
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.typeId = typeId || null
    this.type = type || this.typeId
    this.active = active || false
    this.categoryId = categoryId || null
    this.category = category || this.categoryId
    this.keyConfigurationId = keyConfigurationId || null
    this.lastKeyGeneratedAt = lastKeyGeneratedAt || null
    this.dietRestrictions = dietRestrictions || null
    this.registrationCard = registrationCard || null
    this.registrationCardTotalSteps = registrationCardTotalSteps ||null
    this.registrationCardCompletedSteps = registrationCardCompletedSteps || null
  }
  serialize (editedFields) {
    let item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      bookingId: item.bookingId,
      roomId: item.roomId,
      checkin: item.checkin,
      checkout: item.checkout,
      profileId: item.profileId,
      accountId: item.accountId,
      typeId: item.typeId,
      categoryId: item.categoryId,
      active: item.active
    }
  }
}
